<template>
  <div
    v-if="orderInfo && orderInfo.international_order"
    class="international-component"
  >
    <div class="international-container">
      <h4 class="integrated-shipment-headers">International</h4>
      <label>Currency</label>
      <input
        type="text"
        :value="orderInfo.carrier_info.currency"
        @input="updateCurrency"
      />
      <label>Declared Value:</label>
      <input
        type="number"
        :value="orderInfo.carrier_info.international_value"
        @input="updateValue"
      />
      <div v-if="requiresItn">
        <label>ITN:</label>
        <input
          type="text"
          @input="updateItn"
          :value="orderInfo.carrier_info.international_itn"
        />
      </div>
      <label>Description</label>
      <textarea
        :value="orderInfo.carrier_info.description"
        @input="updateDescription"
      ></textarea>
      <label for="duty-payment">Duty Payment:</label>
      <select id="duty-payment" @change="updateDuty">
        <option
          :selected="
            orderInfo && orderInfo.carrier_info.international_duty === 'sender'
          "
          value="sender"
        >
          Sender
        </option>
        <option
          :selected="
            orderInfo &&
            orderInfo.carrier_info.international_duty === 'recipient'
          "
          value="recipient"
        >
          Recipient
        </option>
      </select>
      <div
        v-if="
          orderInfo && orderInfo.carrier_info.international_duty === 'recipient'
        "
      >
        <label for="duty-account">Duty Account:</label>
        <input
          id="duty-account"
          type="text"
          :value="orderInfo.carrier_info.international_duty_account"
          @input="updateDutyAccount"
        />
        <label for="duty-postal-code">Duty Postal Code:</label>
        <input
          id="duty-postal-code"
          type="text"
          :value="orderInfo.carrier_info.international_duty_postal_code"
          @input="updateDutyPostalCode"
        />
        <label for="duty-country-code">Duty Country Code:</label>
        <input
          id="duty-country-code"
          type="text"
          :value="orderInfo.carrier_info.international_duty_country_code"
          @input="updateDutyCountryCode"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  props: ["orderInfo"],
  methods: {
    updateValue(e) {
      this.$emit("updateValue", e.target.value);
    },
    updateDutyAccount(e) {
      this.$emit("updateDutyAccount", e.target.value);
    },
    updateDutyPostalCode(e) {
      this.$emit("updateDutyPostalCode", e.target.value);
    },
    updateDutyCountryCode(e) {
      this.$emit("updateDutyCountryCode", e.target.value);
    },
    updateItn(e) {
      this.$emit("updateItn", e.target.value);
    },
    updateDuty(e) {
      this.$emit("updateDuty", e.target.value);
    },
    updateCurrency(e) {
      this.$emit("updateCurrency", e.target.value);
    },
    updateDescription(e) {
      this.$emit("updateDescription", e.target.value);
    },
    updateUnitPrice(e) {
      this.$emit("updateUnitPrice", e.target.value);
    },
  },
  computed: {
    requiresItn: function () {
      return (
        parseInt(this.$props.orderInfo.carrier_info.international_value) >= 2500
      );
    },
  },
};
</script>

<style scoped>
.international-component {
  display: inline-block;
  width: 581px;
  margin-left: 6px;
}

.international-container {
  display: inline-block;
  padding: 1rem;
  height: 48vh;
  overflow: auto;
  border: 1px solid black;
  box-sizing: border-box;
  width: 100%;
}
h4 {
  margin: -1rem;
  margin-bottom: 1rem;
}

textarea {
  width: 95%;
  height: 91px !important;
}

input {
  width: 93%;
}

label {
  display: inline-block;
}

select {
  width: 100%;
}
</style>
